import { FC } from "react";
import styles from "./PlanDetails.module.scss";

export const PlanDetailsHeader: FC = () => (
    <span className={styles.planDetailsHeader}>Clients</span>
);
